import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { useNavigate, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import {
  getManufacturesDropdowns,
  getSitesDropdownByManufacturerID,
  getDevicesDropdownBySiteID,
  getParticipantsGroupDropdownBySiteID,
  submitFormData,
} from "../../Utils/adminFunctions";
import { minCurrentDate } from "../../Utils/commonFunctions";

function AdminAddSurvey() {
  const { ip_address } = useContext(globalInfo);
  const [minDate, setMinDate] = useState(null);

  const navigate = useNavigate();
  const [listManufactures, setListManufactures] = useState("");
  const [listSites, setListSites] = useState("");
  const [listDevices, setListDevices] = useState("");
  const [listParticipantsgroup, setListPaticipantsgroup] = useState("");
  const [manufactureID, setManufactureID] = useState("");
  const [siteID, setSiteID] = useState("");
  const [deviceID, setDeviceID] = useState("");
  const [survayName, setSurveyName] = useState("");
  const [participantGroupId, setParticipantGroupId] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [participantQualification, setParticipantQualification] = useState("");
  const [consentStatement, setConsentStatement] = useState("");

  const [errors, setErrors] = useState({});
  useEffect(() => {
    getManufacturesList();
    setMinDate(minCurrentDate);
  }, []);

  const getManufacturesList = async () => {
    try {
      const response = await getManufacturesDropdowns();
      setListManufactures(response.optionItems);
    } catch (error) {
      setListManufactures("");
    }
  };

  const getSitesByMfID = async (manufacture_id) => {
    try {
      const response = await getSitesDropdownByManufacturerID(manufacture_id);
      setListSites(response.optionItems);
    } catch (error) {
      setListSites("");
    }
  };

  const getDevicesBySiteId = async (site_id) => {
    try {
      const response = await getDevicesDropdownBySiteID(site_id);
      setListDevices(response.optionItems);
    } catch (error) {
      setListDevices("");
    }
  };

  const getParticipantsGroupBySiteID = async (site_id) => {
    try {
      const response = await getParticipantsGroupDropdownBySiteID(site_id);
      setListPaticipantsgroup(response.optionItems);
    } catch (error) {
      setListPaticipantsgroup("");
    }
  };
  const getParticipantsByGroupId = async (participant_group_id) => {
    try {
      console.log(participant_group_id);
    } catch (error) {}
  };
  const submitSurvey = async (e) => {
    e.preventDefault();
    let errors = {};
    let formIsValid = true;
    if (!manufactureID) {
      formIsValid = false;
      errors["manufactureID"] = "Please select manufacturer.";
    }
    if (!siteID) {
      formIsValid = false;
      errors["siteID"] = "Please select site.";
    }
    if (!deviceID) {
      formIsValid = false;
      errors["deviceID"] = "Please select device.";
    }
    if (!survayName) {
      formIsValid = false;
      errors["survayName"] = "Please enter survey name.";
    }
    if (!participantGroupId) {
      formIsValid = false;
      errors["participantGroupId"] = "Please select participant group.";
    }
    if (!completionDate) {
      formIsValid = false;
      errors["completionDate"] = "Please enter date.";
    }
    if (!participantQualification) {
      formIsValid = false;
      errors["participantQualification"] =
        "Please select participant qualification.";
    }
    if (!consentStatement) {
      formIsValid = false;
      errors["consentStatement"] = "Please enter consent statement.";
    }
    if (formIsValid) {
      const bodyFormData = new FormData();
      bodyFormData.append("manufacturer_id", manufactureID);
      bodyFormData.append("site_id", siteID);
      bodyFormData.append("device_id", deviceID);
      bodyFormData.append("survey_name", survayName);
      bodyFormData.append("participant_group_id", participantGroupId);
      bodyFormData.append("completion_date", completionDate);
      bodyFormData.append(
        "participant_qualification",
        participantQualification
      );
      bodyFormData.append("consent_statement", consentStatement);
      bodyFormData.append("entered_by_ip", ip_address);
      const response = await submitFormData("addSurvey", bodyFormData);
      if (response.status == "success") {
        setListManufactures("");
        setSiteID("");
        setDeviceID("");
        setSurveyName("");
        setParticipantGroupId("");
        setCompletionDate("");
        setParticipantQualification("");
        setConsentStatement("");
        const sID = response.extra_data.survey_id;
        if (response.extra_data.participant_qualification == "yes") {
          navigate("/AdminAddParticipantQualification/" + sID);
        } else {
          navigate("/AdminCreateSurveyQuestion/" + sID);
        }
      } else {
        toast.warning(response.message, { autoClose: 1500 });
      }
    } else {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setErrors(errors);
      return false;
    }
  };

  return (
    <div>
      
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to="/survey"
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <form
                          method="post"
                          action="post"
                          encType="multipart/form-data"
                        >
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Company Name<i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control" +
                                    (errors.manufactureID ? " is-invalid" : "")
                                  }
                                  onChange={(e) => {
                                    getSitesByMfID(e.target.value);
                                    setManufactureID(e.target.value);
                                    setErrors("manufactureID", "");
                                  }}
                                >
                                  <option value="">Select Company</option>
                                  {listManufactures}
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Site Name<i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control" +
                                    (errors.siteID ? " is-invalid" : "")
                                  }
                                  onChange={(e) => {
                                    getDevicesBySiteId(e.target.value);
                                    getParticipantsGroupBySiteID(
                                      e.target.value
                                    );
                                    setSiteID(e.target.value);
                                    setErrors("siteID", "");
                                  }}
                                >
                                  <option value="">Select Site</option>
                                  {listSites}
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Device Name
                                  <i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control" +
                                    (errors.deviceID ? " is-invalid" : "")
                                  }
                                  onChange={(e) => {
                                    setDeviceID(e.target.value);
                                    setErrors("deviceID", "");
                                  }}
                                >
                                  <option value="">Select Device</option>
                                  {listDevices}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Survey Name
                                  <i className="text-danger">*</i>
                                </span>
                                <input
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.survayName ? " is-invalid" : "")
                                  }
                                  placeholder="Survey Name"
                                  value={survayName}
                                  onChange={(e) => {
                                    setSurveyName(e.target.value);
                                    setErrors("survayName", "");
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Participant Group
                                  <i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control" +
                                    (errors.participantGroupId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    setParticipantGroupId(e.target.value);
                                    setErrors("participantGroupId", "");
                                    getParticipantsByGroupId(e.target.value);
                                  }}
                                >
                                  <option>Select Participant Group</option>
                                  {listParticipantsgroup}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Completion Date
                                  <i className="text-danger">*</i>
                                </span>

                                <input
                                  type="date"
                                  min={minDate}
                                  className={
                                    "form-control" +
                                    (errors.completionDate ? " is-invalid" : "")
                                  }
                                  placeholder="Completion Date"
                                  onChange={(e) => {
                                    setCompletionDate(e.target.value);
                                    setErrors("completionDate", "");
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Participant Qualification
                                  <i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control" +
                                    (errors.participantQualification
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    setParticipantQualification(e.target.value);
                                    setErrors("participantQualification", "");
                                  }}
                                >
                                  <option value="">
                                    Select Participant Qualification
                                  </option>
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Consent Statement
                                  <i className="text-danger">*</i>
                                </span>
                                <textarea
                                  className={
                                    "form-control" +
                                    (errors.consentStatement
                                      ? " is-invalid"
                                      : "")
                                  }
                                  rows={5}
                                  placeholder="Enter ..."
                                  value={consentStatement}
                                  onChange={(e) => {
                                    setConsentStatement(e.target.value);
                                    setErrors("consentStatement", "");
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary pull-right"
                                onClick={submitSurvey}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
}

export default AdminAddSurvey;
